import { useState } from 'react';
import { de } from '@/i18n/de';
import { useAppStore } from '@/lib/store';
import { wsClient } from '@/lib/wsClient';
import { useWakeLock } from '@/lib/wakeLock';
import { AppShell } from '@/components/AppShell';
import { GameHeader } from '@/components/GameHeader';
import { Timer } from '@/components/Timer';
import { PlayerCard } from '@/components/PlayerCard';
import { Button } from '@/components/Button';

export function DiscussionScreen() {
  const view = useAppStore((s) => s.view);
  const [starting, setStarting] = useState(false);
  useWakeLock(true);
  if (!view) return null;

  return (
    <AppShell
      header={<GameHeader view={view} />}
      footer={
        view.self.isHost ? (
          <Button
            fullWidth
            pending={starting}
            onClick={() => {
              setStarting(true);
              wsClient.send({ type: 'round:startVoting' });
            }}
          >
            {de.discussion.startVoting}
          </Button>
        ) : undefined
      }
    >
      <div className="mx-auto flex h-full max-w-md flex-col items-center gap-8 py-4">
        <h1 className="font-display text-lg font-semibold text-fg-muted">
          {de.discussion.title(view.roundNumber)}
        </h1>

        <Timer
          endsAt={view.phaseEndsAt}
          totalSeconds={view.settings.discussionSeconds}
          size={240}
          label={de.common.timerDiscussion}
        />

        {/* Ausgeschiedene hatten hier bisher denselben Aufruf wie alle anderen,
            obwohl sie nicht mitreden. `VotingScreen` sagt es ihnen bereits. */}
        <p className="text-center text-lg text-fg-muted">
          {view.self.alive ? de.discussion.hint : de.voting.spectating}
        </p>

        <ul className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2">
          {view.players.map((player) => (
            <li key={player.id}>
              <PlayerCard player={player} isSelf={player.id === view.self.id} />
            </li>
          ))}
        </ul>
      </div>
    </AppShell>
  );
}
